import {
  SEARCH_ON_LOAD,
  SEARCH_ON_LOAD_SUCCESS,
  SEARCH_FILTER,
  SEARCH_FILTER_SUCCESS,
  SEARCH_RESET,
  SEARCH_DETAILS_SUCCESS,
  SEARCH_EXPORT_CSV,
  SEARCH_DETAILS_RESET,
  SEARCH_ERROR,
  RETRIEVE_MTCN_SUCCESS,
  RETRIEVE_MTCN_RESET, TRANSACTION_QUERY, TRANSACTION_QUERY_SUCCESS, TRANSACTION_QUERY_FAILURE
} from './actions';

const initialState = {
  selectLoad: false,
  selectData: null,
  filterData: null,
  params: null,
  detailsData: null,
  exportDataCount: null,
  messageType: null,
  message: '',
  // queryData: null,
  isQuerying:false,
  queryMessage: '',
}

export function searchReducer(state = initialState, action) {
  let data = action.payload;
  switch (action.type) {
    case SEARCH_ERROR:
      return {
        ...state,
        messageType: 'error',
        message: data.response?.data[0].message?data.response?.data[0].message:data[0]?.message?data[0]?.message:data.data[0]?.message
      }
    case SEARCH_ON_LOAD:
      return {
        ...state,
        selectLoad: false,
        messageType: null,
        message: ''
      }

    case SEARCH_ON_LOAD_SUCCESS:
      return {
        ...state,
        selectData: data,
        selectLoad: true,
        messageType: null,
        message: ''
      }

    case SEARCH_FILTER:
      return {
        ...state,
        params: data,
        messageType: null,
        message: ''
      }

    case SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        filterData: data,
        messageType: null,
        message: ''
      }

    case SEARCH_RESET:
      return {
        selectLoad: false,
        selectData: null,
        filterData: null,
        params: null,
        detailsData: null,
        messageType: null,
        message: ''
      }

    case SEARCH_DETAILS_SUCCESS:
      return {
        ...state,
        detailsData: data,
        messageType: null,
        message: ''
      }

    case SEARCH_DETAILS_RESET:
      return {
        ...state,
        detailsData: null,
        messageType: null,
        message: ''
      }
    case SEARCH_EXPORT_CSV:
      return {
        ...state,
        exportDataCount: data,
        messageType: null,
        message: ''
      }

    case RETRIEVE_MTCN_SUCCESS:
      return {
        ...state,
        mtcn: data
      }

    case RETRIEVE_MTCN_RESET:
      return {
        ...state,
        mtcn: null
      }
    case TRANSACTION_QUERY:
      return {
        ...state,
        queryData: [],
        isQuerying: true,
        queryMessage: ""
      }

    case TRANSACTION_QUERY_SUCCESS:
      return {
        ...state,
        queryData: data,
        isQuerying: false,
        queryMessage: "Query transaction successful."
      }

    case TRANSACTION_QUERY_FAILURE:
      return {
        ...state,
        queryData: null,
        isQuerying: false,
        queryMessage: `Error code: ${data?.response?.data?.[0]?.code}, message: ${data?.response?.data?.[0]?.message}`
      }
    default:
      return state;
  }
}
